import { ToolSidebar } from 'components/minute/sidebar/ToolSidebar';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ToolPanel = (props: Props) => {
    return (
        <S_ToolPanel className={props.className}>
            <ScrollVertical light={true}>
                <ToolSidebar />
            </ScrollVertical>
        </S_ToolPanel>
    );
};

const S_ToolPanel = styled.div`
    width: 100%;
    height: 100%;
`;
